import { render } from "./CVView.vue?vue&type=template&id=15392801&scoped=true&ts=true"
import script from "./CVView.vue?vue&type=script&lang=ts"
export * from "./CVView.vue?vue&type=script&lang=ts"

import "./CVView.vue?vue&type=style&index=0&id=15392801&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15392801"]])

export default __exports__